import { Layout } from './Layout';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import drawing from '../drawing.svg';

type HomeProps = {
  setUsername?: (name: string) => void;
  setIsNew: (isNew: boolean) => void;
};

export const Home = ({ setUsername, setIsNew }: HomeProps) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  const onCreateRoom = async (formData: any) => {
    setIsNew(true);
    const name = formData.get('name');
    setUsername?.(name);
    setIsDisabled(true);
    const channelId = crypto.randomUUID();
    navigate(`/list/${channelId}`);
  };

  // <img src={logo} className="App-logo" alt="logo" />;

  return (
    <Layout>
      <div className="flex flex-row items-center justify-center w-full">
        <div className="flex flex-col max-w-screen-md w-full gap-4 items-center">
          {/* @ts-ignore */}
          <form className="w-full gap-4 flex flex-row" action={onCreateRoom}>
            {/* <input
              disabled={isDisabled}
              required
              className="w-2/3 border rounded p-2"
              placeholder="Enter name"
              name="name"
            /> */}
            <button
              disabled={isDisabled}
              className="w-full p-2 border-2 rounded-lg bg-gray-100 hover:bg-gray-200 active:bg-gray-300"
            >
              Create a collaborative to-do list!
            </button>
          </form>
          <div className="flex flex-col gap-2 w-full">
            <p className="text-lg font-semibold">
              Create a to-do list and share with others
            </p>
            <p className="text-base">
              This web-app allows you to collaborate with others online, you can
              also be in multiple different todo lists at the same time
            </p>
          </div>
          <div className="flex flex-col gap-2 w-full">
            <p className="text-lg font-semibold">How?</p>
            <a
              href={drawing}
              className="rounded max-w-96 self-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={drawing}
                alt="diagram explaining the app's dataflow"
                className="rounded max-w-96 self-center"
              />
            </a>
            <p className="text-base">
              At a high level this web-app is built as a serverless application
              on a JAMstack architechture. It makes use of Netlify to host the
              front-end in their CDN network, while the lambda functions managed
              by Netlify as well using AWS behind the scenes. The Lambda
              functions are wired to a managed MongoDB cluster while using
              Mongoose as its ODM. The real time communication is fully managed
              by Ably, which works as a stateless socket server in a
              subscription/publisher model.Lastly, Tailwind CSS is used as the
              design framework, offering a utility-first approach for building
              responsive, modern, and customizable user interfaces efficiently.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};
